// 浏览器消息模型
class BrowerNoticeModel {
  tag: string;
  title: string;
  body: string;
  icon: string;
  handle: any;
}

export default BrowerNoticeModel;
